var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: { width: _vm.dialogWidth },
      on: {
        keydown: function ($event) {
          if (
            !$event.type.indexOf("key") &&
            _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
          )
            return null
          $event.preventDefault()
          return _vm.onenter.apply(null, arguments)
        },
      },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c(
        "v-card",
        {
          staticClass: "resizable-card",
          class: { "no-select": _vm.resizing },
          style: { height: _vm.dialogHeight + "px" },
        },
        [
          _c(
            "v-card-title",
            [
              _c("span", { staticClass: "headline" }, [
                _vm._v("Currency (" + _vm._s(_vm.rules.name) + ")"),
              ]),
              _c("v-spacer"),
              _c("r-authorize", {
                attrs: {
                  master: _vm.masterAccess,
                  locked: _vm.model.locked,
                  enabled: _vm.model.enabled,
                },
                on: {
                  "update:locked": function ($event) {
                    return _vm.$set(_vm.model, "locked", $event)
                  },
                  "update:enabled": function ($event) {
                    return _vm.$set(_vm.model, "enabled", $event)
                  },
                },
              }),
            ],
            1
          ),
          _c(
            "v-card-text",
            { staticClass: "resizable-card__body" },
            [
              _c(
                "v-col",
                { attrs: { cols: "4", sm: "2", md: "2" } },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mr-2",
                      attrs: { small: "" },
                      on: {
                        click: function ($event) {
                          return _vm.showPreview()
                        },
                      },
                    },
                    [_vm._v("View JSON")]
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-currency-kind-dropdown", {
                        attrs: { model: _vm.model.kind },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "kind", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      _c("r-currency-group-dropdown", {
                        attrs: { model: _vm.model.group },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "group", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      _c("v-text-field", {
                        attrs: { label: "Order:" },
                        model: {
                          value: _vm.model.order,
                          callback: function ($$v) {
                            _vm.$set(_vm.model, "order", _vm._n($$v))
                          },
                          expression: "model.order",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { attrs: { dense: "" } },
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12", sm: "4", md: "4" } },
                    [
                      !!_vm.model.search
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: { small: "", color: "success" },
                              on: { click: _vm.onSearch },
                            },
                            [_vm._v(" Search ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: { click: _vm.onSearch },
                            },
                            [_vm._v(" Search ")]
                          ),
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4", sm: "4" } },
                    [
                      !!_vm.model.deprecate
                        ? _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: { small: "", color: "success" },
                              on: { click: _vm.onDeprecate },
                            },
                            [_vm._v(" Deprecate Config ")]
                          )
                        : _c(
                            "v-btn",
                            {
                              staticClass: "my-1 fill-width",
                              attrs: {
                                small: "",
                                outlined: "",
                                color: "primary",
                              },
                              on: { click: _vm.onDeprecate },
                            },
                            [_vm._v(" Deprecate Config ")]
                          ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mb-2 mt-4", attrs: { dense: "" } },
                [_c("v-divider")],
                1
              ),
              _c(
                "v-expansion-panels",
                [
                  _c("r-guard-panel", {
                    attrs: { model: _vm.model.guard },
                    on: {
                      "update:model": function ($event) {
                        return _vm.$set(_vm.model, "guard", $event)
                      },
                    },
                  }),
                  _c("r-currency-formula-panel", {
                    attrs: { items: _vm.model.formulas, title: "Formulas" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "formulas", $event)
                      },
                    },
                  }),
                  _c("r-item-panel", {
                    attrs: { items: _vm.model.customers, title: "Customers" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "customers", $event)
                      },
                    },
                  }),
                  _c("r-item-panel", {
                    attrs: { items: _vm.model.emitters, title: "Emitters" },
                    on: {
                      "update:items": function ($event) {
                        return _vm.$set(_vm.model, "emitters", $event)
                      },
                    },
                  }),
                  _c(
                    "r-panel",
                    { attrs: { title: "Map Group" } },
                    [
                      _c("r-map-group-dropdown", {
                        attrs: { model: _vm.model.mapGroup },
                        on: {
                          "update:model": function ($event) {
                            return _vm.$set(_vm.model, "mapGroup", $event)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "v-card-actions",
            { staticClass: "resizable-card__actions" },
            [
              _c("v-spacer"),
              _c(
                "v-btn",
                {
                  attrs: { color: "blue darken-1", text: "" },
                  on: { click: _vm.cancel },
                },
                [_vm._v(" Cancel ")]
              ),
              !_vm.lockedAssess || _vm.masterAccess
                ? _c(
                    "v-btn",
                    {
                      attrs: { color: "blue darken-1", text: "" },
                      on: { click: _vm.save },
                    },
                    [_vm._v(" Save ")]
                  )
                : _vm._e(),
            ],
            1
          ),
          _c("div", {
            staticClass: "resize-handle",
            on: {
              mousedown: function ($event) {
                $event.stopPropagation()
                $event.preventDefault()
                return _vm.startResize.apply(null, arguments)
              },
            },
          }),
        ],
        1
      ),
      _c("r-search-dialog", { ref: "r-search-dialog" }),
      _c("r-currency-deprecate-dialog", { ref: "r-currency-deprecate-dialog" }),
      _c("r-preview-dialog", { ref: "preview-dialog" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }